import { render, staticRenderFns } from "./TableSkeleton.vue?vue&type=template&id=edf8340c&scoped=true"
import script from "./TableSkeleton.vue?vue&type=script&lang=js"
export * from "./TableSkeleton.vue?vue&type=script&lang=js"
import style0 from "./TableSkeleton.vue?vue&type=style&index=0&id=edf8340c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edf8340c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/al-khaleej/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('edf8340c')) {
      api.createRecord('edf8340c', component.options)
    } else {
      api.reload('edf8340c', component.options)
    }
    module.hot.accept("./TableSkeleton.vue?vue&type=template&id=edf8340c&scoped=true", function () {
      api.rerender('edf8340c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/global/TableSkeleton.vue"
export default component.exports